/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class medication extends IceEntity {
	medication_key = "";
  trans_account = "";
  ndc_code = "";
  state_type = 0;
  state_reason = "";
  medication_type = 0;
  medication_title = "";
  number_of_refills = 0;
  number_of_remaining_days = 0;
  immunization_type = 0;
  record_version = 0;
  offline_record_status = 0;
  accessed = NaN;
  accessed_user = "";
  created = NaN;
  created_user = "";
  modified = NaN;
  modified_user = "";

  gettablename(): string {
    return "MEDICATION";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "NOTES") return true;
    else if (ColumnName == "ACTY") return true;
    else if (ColumnName == "GLRULES") return true;
    else if (ColumnName == "EXTDATAREFS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "NOTES") return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";
    else if (ColumnName == "ACTY") return "MEDICATION_ACTIVITY";
    else if (ColumnName == "GLRULES") return "MANAGEMENT_GUIDELINE";
    else if (ColumnName == "EXTDATAREFS") return "EXTERNAL_DATA_REFERENCE";

    return null;
  }
}
